import { toSafeLowerString, toSafeString } from '@shared/utils';
import getInteractionEventId from '@/lib/threadInteractions/getInteractionEventId.js';

const resolveApprovalDecisionsFromActivity = ({ activity = [] } = {}) => {
  if (!Array.isArray(activity) || activity.length < 1) {
    return activity;
  }

  const decisionByInteractionId = new Map();

  for (const item of activity) {
    const interactionId = getInteractionEventId(item);
    const response = item?.response;

    if (!interactionId || !response || typeof response !== 'object' || Array.isArray(response) || typeof response.decision !== 'boolean') {
      continue;
    }

    decisionByInteractionId.set(interactionId, response.decision ? (response.remember === true ? 'always_allow' : 'allow') : 'deny');
  }

  if (decisionByInteractionId.size < 1) {
    return activity;
  }

  let didResolveDecision = false;
  const resolvedActivity = activity.map((item) => {
    if (toSafeLowerString(item?.type) !== 'approval' || toSafeString(item?.decision)) {
      return item;
    }

    const interactionId = getInteractionEventId(item);
    const decision = decisionByInteractionId.get(interactionId);

    if (!decision) {
      return item;
    }

    didResolveDecision = true;
    return {
      ...item,
      decision
    };
  });

  return didResolveDecision ? resolvedActivity : activity;
};

export default resolveApprovalDecisionsFromActivity;
